import { useEffect, useRef } from "react";
import Hls from "hls.js";

/**
 * Universal video element that works for MP4 and HLS (m3u8).
 * Falls back to native playback on Safari for HLS.
 */
export default function HlsVideo({ src, className = "", controls = false, autoPlay = false, ...rest }) {
  const ref = useRef(null);

  useEffect(() => {
    const v = ref.current;
    if (!v || !src) return;

    let hls;
    const isHls = /\.m3u8($|\?)/i.test(src);

    if (isHls && Hls.isSupported()) {
      hls = new Hls({ enableWorker: true });
      hls.loadSource(src);
      hls.attachMedia(v);
    } else {
      // MP4 or native HLS (Safari)
      v.src = src;
    }

    return () => {
      if (hls) hls.destroy();
    };
  }, [src]);

  return (
    <video
      ref={ref}
      className={className}
      controls={controls}
      autoPlay={autoPlay}
      playsInline
      {...rest}
    />
  );
}
